import React from "react";
import { Loading } from "../../App";
import Ajax, { domain } from "../ajax/Ajax";

class Orders extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: null,
      fetching: false,
    };
  }

  async fetchOrders() {
    let institution = this.props.focusObj.institution;
    let fetchResults = await Ajax.fetchData(
      domain + "/en/api/shop/v1/order/?institution=" + institution
    );
    if (fetchResults) {
      this.setState({
        orders: fetchResults.data,
        fetching: false,
      });
    }
  }

  componentDidMount() {
    this.fetchOrders();
  }

  render() {
    return (
      <div className="card orders is-shadowless bordered-card is-fullwidth">
        <div className="card-header">
          <div className="card-header-title">
            CLIENT ORDERS
            <span className="ml-2">
              {this.state.orders ? (
                <span>
                  {this.state.orders.length > 0 ? (
                    <span className="tag is-rounded is-danger">
                      {this.state.orders.length}
                    </span>
                  ) : (
                    <span></span>
                  )}
                </span>
              ) : (
                <span></span>
              )}
            </span>
          </div>
        </div>
        <div className="card-content">
          {this.state.orders ? (
            <table className="table is-hoverable is-fullwidth">
              <thead>
                <tr>
                  <td>Date</td>
                  <td>Name</td>
                  <td>Phone</td>
                  <td>Address</td>
                  <td>Products</td>
                  <td>Status</td>
                </tr>
              </thead>
              <tbody>
                {this.state.orders.map((order) => (
                  <tr key={order.id + "-online-order"}>
                    <td>
                      {new Date(order.date).toDateString()}{" "}
                      {new Date(order.date).toLocaleTimeString()}
                    </td>
                    <td>{order.name}</td>
                    <td>{order.phone}</td>
                    <td>{order.email}</td>
                    <td>
                      <div className="d-flex justify-content-between">
                        <div>Flat Screen T.V</div>
                        <div>Q. 1</div>
                      </div>
                    </td>
                    <td>
                      {order.processed ? (
                        <span>
                          <span className="zmdi zmdi-check-circle mr-1 has-text-success"></span>
                          Processed
                        </span>
                      ) : (
                        <span>Pending</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>
              <Loading />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Orders;
